<template>
  <div style="width: 100%; max-width: 100%; overflow: hidden" class="py-2">
    <div id="chart" ref="chart"></div>
  </div>
</template>
<script>
import { createChart } from "lightweight-charts";
// import apiUrl from "@/common/apiUrl";
// import Axios from "@/api/newAxios";

export default {
  name: "LightWeightGraph",
  props: {
    security: {},
    value: {},
    graph: {},
  },
  data() {
    return {
      data: [],
      chart: null,
      timeSeries: [],
      filterValue: 0,
      filterItems: [
        // { text: "1D", value: "1DAY" },
        { text: "1W", value: "1WEEK" },
        { text: "1M", value: "1MONTH" },
        { text: "3M", value: "3MONTH" },
        { text: "6M", value: "6MONTH" },
        { text: "1Y", value: "1YEAR" },
        { text: "All", value: "ALL" },
      ],
    };
  },
  computed: {
    timeSeriesFilter() {
      return this.filterItems[this.filterValue].value;
    },
  },
  watch: {
    graph(value) {
      this.changeHandler(value);
    },
  },
  methods: {
    changeHandler() {
      if (this.graph == 0) {
        this.loadGraph();
      } else {
        this.changeGraph();
      }
    },
    changeGraph() {
      if (this.chart) {
        this.chart.remove();
        this.chart = null;
      }
      let element = document.getElementById("chart");
      this.chart = createChart(element, {
        height: this.$vuetify.breakpoint.smAndUp ? 500 : 300,
        layout: {
          textColor: "black",
          background: { type: "solid", color: "white" },
        },
      });
      const candlestickSeries = this.chart.addCandlestickSeries({
        upColor: "#26a69a",
        downColor: "#ef5350",
        borderVisible: true,
        wickUpColor: "#26a69a",
        wickDownColor: "#ef5350",
        wickVisible: true,
        HandleScrollOptions: {
          mouseWheel: this.$vuetify.breakpoint.smAndUp ? true : false,
          pressedMouseMove: this.$vuetify.breakpoint.smAndUp ? false : true,
        },
      });
      candlestickSeries.setData(this.value);
      this.chart.timeScale().fitContent();
    },
    loadGraph() {
      if (this.chart) {
        this.chart.remove();
        this.chart = null;
      }
      let element = document.getElementById("chart");
      this.chart = createChart(element, {
        height: this.$vuetify.breakpoint.smAndUp ? 500 : 300,
        layout: {
          textColor: "black",
          background: { type: "solid", color: "white" },
        },
      });
      const lineSeries = this.chart.addAreaSeries();
      lineSeries.setData(this.value);
      this.chart.timeScale().fitContent();
    },
  },
  mounted() {
    this.changeHandler();
  },
  unmounted() {
    if (this.chart) {
      this.chart.remove();
      this.chart = null;
    }
  },
};
</script>
